import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from './services/local-storage/local-storage.service';

/**
 * O back lê a unidade deste cabeçalho: a adesão CartãoSiM só libera nas unidades piloto, e a
 * Agenda tira dela a marca (nunca do hostname), os relatórios da Agenda e os recados do chat médico.
 */
@Injectable()
export class UnidadeAdesaoInterceptor implements HttpInterceptor {

  constructor(private localStorageService: LocalStorageService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const unidade = this.localStorageService.get('currentUnit');
    if (!UnidadeAdesaoInterceptor.precisaUnidade(req.url) || unidade == null || unidade === '') return next.handle(req);

    return next.handle(req.clone({ setHeaders: { 'X-Unidade': String(unidade) } }));
  }

  // '/Agenda/' com as barras: não pega '/AgendaFila/', que não lê o cabeçalho.
  static precisaUnidade(url: string): boolean {
    return url.includes('/adesao') || url.includes('/Agenda/') || url.includes('/relatorios/agenda') || url.includes('/recados');
  }
}
